module.exports = __webpack_public_path__ + "media/WenJingVideo.adf03aec.mp4";